import './polyfill';
import './registerServiceWorker';

import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import Notifications from 'vue-notification';
import { sync } from 'vuex-router-sync';

import filters from '@/filters/filters';
import { hasAccess } from '@/libs/userAbility/userAbilityChecker';
import PrevRoute from '@/plugins/prevRoute';
import RoleAccessPlugin from '@/plugins/roleAccess';

import App from './App.vue';
// import cssVars from 'css-vars-ponyfill'
import router from './router/index';
import store from './store/index';

Object.assign(window, Vue);
sync(store, router);

// Registering filters
for (const filter of filters) {
    Vue.filter(filter.name, filter.filter);
}


Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: 'veeFields'
});
Vue.use(RoleAccessPlugin);
Vue.use(Notifications);
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(BootstrapVue);

Vue.use(PrevRoute);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
